import { Link, MenuItem, MenuList, Typography, useTrackCampaignOnLoad } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import type { Locale } from '@packages/config';
import { useEffect } from 'react';
import type { ServiceMenuEntry } from './ServiceMenuTypes';
import { useServiceMenuData } from './useServiceMenuData';

const ServiceSlotMenuItem = ({
  data,
  defaultLocale,
}: {
  data: ServiceMenuEntry;
  defaultLocale: Locale;
}) => {
  const { translatable_title: title, translatable_url: url, is_external: isExternal } = data;
  const finalLink = url.replace(`/${defaultLocale.substring(0, 2)}/`, '/');
  const { trackClick, trackDisplay } = useTrackCampaignOnLoad(data, finalLink);
  useEffect(() => {
    trackDisplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Link
      href={finalLink}
      key={title}
      noLinkStyle
      openInNewTab={isExternal}
      onClick={() => trackClick()}
    >
      <MenuItem>
        <Typography variant="body2">{title}</Typography>
      </MenuItem>
    </Link>
  );
};

export const ServiceSlotMenuList = () => {
  const {
    headerSlots: { serviceApi },
    i18n: { defaultLocale },
  } = useConfig();

  const data = useServiceMenuData(serviceApi);

  return (
    <MenuList>
      {data.map((dataItem) => (
        <ServiceSlotMenuItem data={dataItem} defaultLocale={defaultLocale} />
      ))}
    </MenuList>
  );
};
